import type { ICellRendererParams } from 'ag-grid-community';
import type { MarketPrice, MarketPriceDataSource } from '../../schema';

const LABELS: Record<MarketPriceDataSource, string> = {
  morning_placeholder: 'Placeholder',
  field: 'Field',
  scrape: 'Scraped',
  field_correction: 'Corrected',
};

// Subtle tonal pills — drawn from the brand tokens, not raw hex. Each colour
// hints at trust: scraped (neutral), field/corrected (human-touched, primary),
// placeholder (warning — not yet validated).
const TONE: Record<MarketPriceDataSource, string> = {
  morning_placeholder: 'bg-warning/[0.12] text-warning',
  field: 'bg-primary/[0.12] text-primary',
  scrape: 'bg-foreground-muted/[0.14] text-foreground-muted',
  field_correction: 'bg-success/[0.14] text-success',
};

export function SourceBadge(p: ICellRendererParams<MarketPrice>) {
  if (!p.data) return null;
  const ds = p.data.dataSource;
  const sourceName = p.data.sourceName;
  return (
    <span className="inline-flex items-center gap-1.5 self-center leading-none">
      <span
        className={`inline-flex h-[20px] items-center rounded-full px-2 text-[11px] font-semibold uppercase tracking-wide ${TONE[ds]}`}
      >
        {LABELS[ds]}
      </span>
      {sourceName && (
        <span className="text-[12px] text-foreground-muted">{sourceName}</span>
      )}
    </span>
  );
}
